/**
 * @desc 列表
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(body: defs.crawler.CrawlerRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/crawler/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
